/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BooleanResponse } from "../models/BooleanResponse";
import type { ContactSupplierRequest } from "../models/ContactSupplierRequest";
import type { CreateNewSampleRequestRequest } from "../models/CreateNewSampleRequestRequest";
import type { Response_AdminContactRequest_ } from "../models/Response_AdminContactRequest_";
import type { Response_AdminSampleRequest_ } from "../models/Response_AdminSampleRequest_";
import type { Response_list_definitions_public_v1_contact_request_ContactRequest__ } from "../models/Response_list_definitions_public_v1_contact_request_ContactRequest__";
import type { Response_list_definitions_public_v1_sample_request_SampleRequest__ } from "../models/Response_list_definitions_public_v1_sample_request_SampleRequest__";
import type { Response_Union_SampleRequest__NoneType__ } from "../models/Response_Union_SampleRequest__NoneType__";
import type { Response_UUID_ } from "../models/Response_UUID_";
import type { UpdateSampleRequestRequest } from "../models/UpdateSampleRequestRequest";
import type { UpsertSampleRequestRawMaterialRequest } from "../models/UpsertSampleRequestRawMaterialRequest";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class SampleRequestService {
  /**
   * Get Submitted Sample Requests
   * @param limit Limit the number of results
   * @returns Response_list_definitions_public_v1_sample_request_SampleRequest__ Successful Response
   * @throws ApiError
   */
  public static sampleRequestGetSubmittedSampleRequests(
    limit: number = 100
  ): CancelablePromise<Response_list_definitions_public_v1_sample_request_SampleRequest__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/sample-requests",
      query: {
        limit: limit,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create New Sample Request
   * @param requestBody
   * @returns Response_UUID_ Successful Response
   * @throws ApiError
   */
  public static sampleRequestCreateNewSampleRequest(
    requestBody: CreateNewSampleRequestRequest
  ): CancelablePromise<Response_UUID_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/sample-requests",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Pending Sample Request
   * @returns Response_Union_SampleRequest__NoneType__ Successful Response
   * @throws ApiError
   */
  public static sampleRequestGetPendingSampleRequest(): CancelablePromise<Response_Union_SampleRequest__NoneType__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/sample-requests/pending",
    });
  }
  /**
   * Delete Sample Request
   * @param sampleRequestId
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static sampleRequestDeleteSampleRequest(
    sampleRequestId: string
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/sample-requests/{sample_request_id}",
      path: {
        sample_request_id: sampleRequestId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Sample Request
   * @param sampleRequestId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static sampleRequestUpdateSampleRequest(
    sampleRequestId: string,
    requestBody: UpdateSampleRequestRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/sample-requests/{sample_request_id}",
      path: {
        sample_request_id: sampleRequestId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upsert Sample Request Raw Material
   * @param sampleRequestId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static sampleRequestUpsertSampleRequestRawMaterial(
    sampleRequestId: string,
    requestBody: UpsertSampleRequestRawMaterialRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/sample-requests/{sample_request_id}/raw-material",
      path: {
        sample_request_id: sampleRequestId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Submit Sample Request
   * @param sampleRequestId
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static sampleRequestSubmitSampleRequest(
    sampleRequestId: string
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/sample-requests/{sample_request_id}/submit",
      path: {
        sample_request_id: sampleRequestId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Sample Request Raw Material
   * @param sampleRequestId
   * @param rawMaterialId
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static sampleRequestRemoveSampleRequestRawMaterial(
    sampleRequestId: string,
    rawMaterialId: string
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/sample-requests/{sample_request_id}/raw-material/{raw_material_id}",
      path: {
        sample_request_id: sampleRequestId,
        raw_material_id: rawMaterialId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * List Contact Requests
   * @param limit Limit the number of results
   * @returns Response_list_definitions_public_v1_contact_request_ContactRequest__ Successful Response
   * @throws ApiError
   */
  public static sampleRequestListContactRequests(
    limit: number = 100
  ): CancelablePromise<Response_list_definitions_public_v1_contact_request_ContactRequest__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/contact-requests",
      query: {
        limit: limit,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Contact Supplier
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static sampleRequestContactSupplier(
    requestBody: ContactSupplierRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/contact-requests",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Internal Sample Request Detail
   * @param sampleRequestId
   * @returns Response_AdminSampleRequest_ Successful Response
   * @throws ApiError
   */
  public static sampleRequestGetInternalSampleRequestDetail(
    sampleRequestId: string
  ): CancelablePromise<Response_AdminSampleRequest_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/sample-requests/internal/{sample_request_id}",
      path: {
        sample_request_id: sampleRequestId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Internal Contact Request Detail
   * @param contactRequestId
   * @returns Response_AdminContactRequest_ Successful Response
   * @throws ApiError
   */
  public static sampleRequestGetInternalContactRequestDetail(
    contactRequestId: string
  ): CancelablePromise<Response_AdminContactRequest_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/contact-requests/internal/{contact_request_id}",
      path: {
        contact_request_id: contactRequestId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
